import { render } from "./MarqueeDialog.vue?vue&type=template&id=7bd476fc&scoped=true"
import script from "./MarqueeDialog.vue?vue&type=script&lang=js"
export * from "./MarqueeDialog.vue?vue&type=script&lang=js"

import "./MarqueeDialog.vue?vue&type=style&index=0&id=7bd476fc&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd476fc"]])

export default __exports__